import { render, staticRenderFns } from "./LogosCountries.vue?vue&type=template&id=2b9bf7c0&"
import script from "./LogosCountries.vue?vue&type=script&lang=js&"
export * from "./LogosCountries.vue?vue&type=script&lang=js&"
import style0 from "./LogosCountries.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports